// components
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Knob } from "react-rotary-knob";
import * as skins from "react-rotary-knob-skin-pack";

//assetes
import layerBack from "assets/images/layer_back.png";
import volumeKnobSkin from "assets/knobSkins/volume";
import volumeRotaryKnobSkin from "assets/knobSkins/volumeJust";
import volumeNumbers from "assets/images/layer_volume_indicator.png";
import pannerNumbers from "assets/images/layer_panner_indicator.png"
import vocal_on from "assets/images/vocal_on.png";
import vocal_off from "assets/images/vocal_off.png";
import filterKnob from "assets/knobSkins/filter";
import volumeKnob from "assets/knobSkins/layerVolume";
import pannerKnob from "assets/knobSkins/panner";
import { Box, Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  layerContainer: {
    left: "4%",
    width: "95%",
    height: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    // backgroundImage: `url(${layerBack})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    // marginTop:"-8%"
  },
  toggleButton: {
    position: "relative",
    top: "10%",
    left: "20%",
    width: "60%",
    height: "60%",
  },
  toggleButtonHorizontal: {
    position: "relative",
    top: "10%",
    left: "20%",
    width: "50%",
    height: "50%",
    // transform:"rotate(90deg)",
  },
  toggleButtonImage: {
    width: "100%",
    height: "100%",
    display: "inline-block",
  },
  layerNameTYpography: {
    position: "relative",
    // top: "5.5vw",
    // left: "-1vw",
    fontSize: "5px",
    left: "1%",
    top: "1%",
    textAlign: "center",
  },
  knobGrid:{
    height:"100%"
  }
}));

/**
 * @component LayerControler
 */
const LayerControler = forwardRef(
  (
    {
      mergerNodeReference,
      audioContextInstance,
      name,
      layerId,
      initialVolume,
      initialPanning,
      src,
      initialMuted,
      layerNumber,
      muteSideEffectFunction,
      announceCurrentPortion,
      stateChanger,
      currentTrackNumber
    },
    ref
  ) => {
    const timestamps = [0, 18, 34, 50, 66, 82, 98, 114, 130, 146, 162, 178, 210, 242, 258, 290, 306, 322, 338, 354, 370, 402, 434, 466, 474, 490, 498, 514, 530, 546, 562, 578, 594, 610];

    const [volume, setVolume] = useState(initialVolume);
    const [panning, setPanning] = useState(initialPanning);
    const [muted, setMuted] = useState(initialMuted);
    const [audioElement, setAudioElement] = useState(null);
    const [biquadFilter1, setBiquadFilter1] = useState(null);
    const [biquadFilter2, setBiquadFilter2] = useState(null);
    const [pannerNode, setPannerNode] = useState(null);
    const [lowpassFrequency, setLowpassFrequency] = useState(20000);
    const [currentTrack, setCurrentTrack] = useState(currentTrackNumber);
    const [highpassFrequency, setHighpassFrequency] = useState(0);

    const [playerState,setPlayerState] = useState("waitingToPlay")




    const classes = useStyles();

    

    // let trackStartTime, trackEndTime, trackDuration;

    // useEffect(()=>{
    //   console.log(playerState)
    //   if(playerState==="notifingOthers"){
    //     setPlayerState("waiting")
    //   }
    //   if(playerState==="playing"){
    //     continueWithMe(name,document.querySelector(`#${name}`).currentTime)
    //   }
    // },[playerState])

    const handelMute = () => {
      audioElement.volume = muted ? volume : 0;
      setMuted(!muted);
      muteSideEffectFunction(layerId);
    };

    const handelVolumeChange = (newVolume) => {
      audioElement.volume = muted ? 0 : newVolume;
      setVolume(newVolume);
    };
    const handelPanningChange = (newPan) => {
      pannerNode.pan.value = newPan;
      setPanning(newPan);
    };

    // const handelNewTrack = (audioElement)=>{
    //   console.log(audioElement)
    //   let interval = setInterval(()=>{audioElement.currentTime-=1
    //   if(audioElement.currentTime<=0) clearInterval(interval)
    //   },50)
    //   setPlayerState("waitingToPlay")
    // }

    useImperativeHandle(ref, () => ({
      play() {
        audioContextInstance.resume();
        audioElement.play();
      },
      pause() {
        audioElement.pause();
      },
      stop() {
        // audioElement.pause();
        // audioElement.currentTime = trackEndTime;
      },
      toggleMute() {
        handelMute();
      },
      changePlaybackSpeed(newSpeed) {
        audioElement.playbackRate = newSpeed;
      },
      changeCurrentTime(newPortion) {
        audioElement.currentTime = newPortion * audioElement.duration;
      },
      // waitForOther(name,time){
      //   audioElement.currentTime=time
      //   audioElement.pause();
      //   setPlayerState("waitingForOther")
      //   // newWaitingList.push(name)

      // },
      // continueFrom(time){
      //   if(playerState!="waitingForOther" && playerState!="waiting") return
      //   if(audioElement.currentTime>=time)
      //     audioElement.currentTime = time
      //   audioElement.play();
      // },
      // continueFromBeginning(when){
      //   // if(playerState!="waitingForPlay") return
      //   audioElement.currentTime =0
      //   // audioElement.play(when);
      //   setPlayerState("waiting")
      // }
    }));

    useEffect(() => {
      // console.log("single time useEffect called!")
      let audioElementInstace = document.querySelector(`#${name}`);

      audioElementInstace.addEventListener("timeupdate", () => {
        if(isNaN(audioElementInstace.duration) || isNaN(audioElementInstace.currentTime)) return 0

        let index = timestamps.filter((element)=> element < audioElementInstace.currentTime).length
        let trackStartTime = timestamps[index-1]
        let trackEndTime = timestamps[index]

        announceCurrentPortion(
          (audioElementInstace.currentTime-trackStartTime) / (trackEndTime-trackStartTime)
        );
        console.log((audioElementInstace.currentTime-trackStartTime) / (trackEndTime-trackStartTime))
        if(audioElementInstace.currentTime>= trackEndTime){
          audioElementInstace.pause()
          stateChanger(name,"ended")
        }
      });
      audioElementInstace.addEventListener("waiting",()=>{
        // console.log(name,"starts to wait", audioElementInstace.currentTime)
        stateChanger(name,"waiting")
      })
      audioElementInstace.addEventListener("canplaythrough",()=>{
        // console.log(name,"starts to play again", audioElementInstace.currentTime)
        stateChanger(name,"readyToPlay")
      })
      // audioElementInstace.addEventListener("load",()=>{
      //   console.log(name,"loads for the first time", audioElementInstace.currentTime)
      //   stateChanger(name,"readyToPlay")
      // })
      audioElementInstace.addEventListener("ended",()=>{
        stateChanger(name,"ended")
      })


      setAudioElement(audioElementInstace);
      let audioTrack =
        audioContextInstance.createMediaElementSource(audioElementInstace);

      let biquadFilter1 = audioContextInstance.createBiquadFilter();
      biquadFilter1.type = "lowpass";
      biquadFilter1.frequency.value = lowpassFrequency;
      setBiquadFilter1(biquadFilter1);
      audioTrack.connect(biquadFilter1);

      let biquadFilter2 = audioContextInstance.createBiquadFilter();
      biquadFilter2.type = "highpass";
      biquadFilter2.frequency.value = highpassFrequency;
      setBiquadFilter2(biquadFilter2);
      biquadFilter1.connect(biquadFilter2);

      let pannerNodeInstance = audioContextInstance.createStereoPanner();
      setPannerNode(pannerNodeInstance);
      biquadFilter2.connect(pannerNodeInstance);

      // pannerNodeInstance.connect(mergerNodeReference,0,0)
      // pannerNodeInstance.connect(mergerNodeReference,0,1)
      biquadFilter2.connect(mergerNodeReference, 0, layerNumber);

      pannerNodeInstance.connect(audioContextInstance.destination);
    }, []);

    return (
      <Grid container className={classes.layerContainer} spacing={1}>
        {/* <div className={classes.layerContainer}> */}
        <audio crossOrigin="anonymous" id={name} src={src}></audio>
        <Grid item xs={2} style={{ height: "100%" }}>
          <div
            onClick={() => handelMute(name)}
            className={classes.toggleButton}
            style={{ height: "80%", top: "1%" }}
          >
            <img
              className={classes.toggleButtonImage}
              src={muted ? vocal_on : vocal_off}
            />
          </div>
          <Typography className={classes.layerNameTYpography}>
            {name}
          </Typography>
        </Grid>

        {/* <section style={{ padding: "10px" }}> */}
        <Grid container item xs={5} style={{ height: "100%" }}>
          <Grid item xs={6} className={classes.knobGrid}>
            {/* <img src={volumeNumbers} style={{height:"100%"}} /> */}
            <Knob
              style={{
                display: "inline-block",
                height: "80%",
                top: "10%",
                width:"100%",
                // transform: "translate(-7%, -150%)",
                // transform: "translateY(50%)",
                // margin: "10px",
              }}
              skin={volumeKnob}
              min={0}
              max={100}
              value={volume * 100}
              unlockDistance={50}
              clampMin={0}
              clampMax={300}
              rotateDegrees={-150}
              onChange={(value) => {
                const maxDistance = 50;
                let distance = Math.abs(value - volume * 100);
                if (distance > maxDistance) {
                  return;
                } else {
                  handelVolumeChange(value / 100.0);
                }
              }}
            />
            
          </Grid>
          <Grid item xs={6} className={classes.knobGrid}>
          {/* <img src={pannerNumbers} style={{height:"80%",top:"10%",position:"relative"}} /> */}
            <Knob
              style={{
                display: "inline-block",
                // transform: "translateY(50%)",
                // margin: "10px",
                width:"100%",
                height: "70%",
                // transform: "translate(-13.2%, -150%)",
                top: "15%",
              }}
              skin={pannerKnob}
              min={-100}
              max={100}
              value={panning * 100}
              unlockDistance={25}
              clampMin={0}
              clampMax={300}
              rotateDegrees={-150}
              onChange={(value) => {
                const maxDistance = 50;
                let distance = Math.abs(value - panning * 100);
                if (distance > maxDistance) {
                  return;
                } else {
                  handelPanningChange(value / 100.0);
                }
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={5}
          style={{ height: "100%" }}
        >
          <Grid item xs={4} className={classes.knobGrid}>
            <Knob
              className={classes.filterKnob}
              skin={filterKnob}
              style={{
                // display: "inline-block",
                // transform: "translateY(50%)",
                // margin: "10px",
                position:'relative',
                height: "70%",
                width:"100%",
                top: "12%",
              }}
              min={0}
              max={20000}
              value={lowpassFrequency}
              unlockDistance={50}
              clampMin={0}
              clampMax={240}
              rotateDegrees={-120}
              onChange={(value) => {
                const maxDistance = 19000;
                let distance = Math.abs(value - lowpassFrequency);
                if (distance > maxDistance) {
                  return;
                } else {
                  setLowpassFrequency(value);
                  biquadFilter1.frequency.value = value;
                }
              }}
            />
          </Grid>
          <Grid item xs={4} className={classes.knobGrid}>
            <Knob
              className={classes.filterKnob}
              skin={filterKnob}
              style={{
                display: "inline-block",
                // transform: "translateY(50%)",
                // margin: "10px",
                height: "70%",
                // left: "10%",
                width:"100%",
                position:'relative',
                top: "12%",
              }}
              min={0}
              max={20000}
              value={highpassFrequency}
              unlockDistance={50}
              clampMin={0}
              clampMax={240}
              rotateDegrees={-120}
              onChange={(value) => {
                const maxDistance = 19000;
                let distance = Math.abs(value - highpassFrequency);
                if (distance > maxDistance) {
                  return;
                } else {
                  setHighpassFrequency(value);
                  biquadFilter2.frequency.value = value;
                }
              }}
            />
          </Grid>
          <Grid item xs={4} className={classes.knobGrid}>
            <Knob
              skin={filterKnob}
              style={{
                position:'relative',
                display: "inline-block",
                // transform: "translateY(50%)",
                // margin: "10px",
                height: "70%",
                width:"100%",
                // left: "10%",
                top: "12%",
              }}
              min={0}
              max={0}
              unlockDistance={50}
              disabled
            />
          </Grid>
        </Grid>
        {/* </section> */}
      </Grid>
    );
  }
);

export default LayerControler;
